import { getType } from 'typesafe-actions'

import { LocationActions } from './actions'
import { LocationState } from './types'

export const initState: LocationState = {
  currentLocationPath: null
}

export const locationReducer = (state: LocationState = initState, action: LocationActions): LocationState => {
  switch (action.type) {
    case getType(LocationActions.setLocation):
      return {
        ...state,
        currentLocationPath: action.payload.currentLocationPath
      }
    default:
      return state
  }
}
